import classes from './CountCard.module.css'

interface ICountCard {
    name: string,
    number: string | number,
    onClick?: ()=>void
}

const CountCard: React.FC<ICountCard> = ({name, number, onClick})=>{

    return(
        <div className={`col-md-5 px-0 ${classes.countCard}`} onClick={onClick}>
            <div className={classes.countCardDiv}>
                <div className={classes.countCardPContainer}>
                    <p style={{alignSelf: 'center', margin: 0, padding: 0, fontWeight: 'bold', fontSize: 25, color: '#fff'}}>
                        {number}
                    </p>
                    <p style={{alignSelf: 'flex-end', margin: 0, padding: 0, color: '#bbb'}}>
                        {name}
                    </p>
                </div>
            </div>
        </div>
    )
}

export default CountCard